/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import FontAwesome from 'react-fontawesome';
import s from './Navigation.css';
import Link from '../Link';

class Navigation extends React.Component {
  render() {
    return (
      <div className={s.root} role="navigation">
        <ul className={s.menu}>
          <li className="">
            <Link className={s.link} to="/">
              Home
            </Link>
          </li>
          <li className="">
            <Link className={s.link} to="#">
              About Us <FontAwesome name="angle-down" />
            </Link>
            <ul className={s.subMenu}>
              <li>
                <Link to="/about-us/company-profile">Company Profile</Link>
              </li>
              <li>
                <Link to="/about-us/meet-our-team">Meet Our Team</Link>
              </li>
              <li>
                <Link to="/about-us/factory-plants">Factory Plants</Link>
              </li>
              <li>
                <Link to="/about-us/quality-policy">Quality Policy</Link>
              </li>
              {/*
              <li>
                <Link to="/about-us/bricks-manufacturing">
                  Bricks Manufacturing
                </Link>
              </li>
              */}
              {/*
              <li>
                <Link to="/about-us/company-profile">Jobs Opportunity</Link>
              </li>
              */}
            </ul>
          </li>
          <li className="">
            <Link className={s.link} to="#">
              Products <FontAwesome name="angle-down" />
            </Link>
            <ul className={s.subMenu}>
              <li>
                <Link to="/products/common-solid-bricks">
                  Common Solid Bricks
                </Link>
              </li>
              <li>
                <Link to="/products/common-blocks">Common Blocks</Link>
              </li>
              <li>
                <Link to="/products/modular-bricks">M211 Modular Bricks</Link>
              </li>
              <li>
                <Link to="/products/facing-brick-rockface">
                  Facing Brick - Rockface
                </Link>
              </li>
              <li>
                <Link to="/products/facing-brick-veneer">
                  Facing Brick - Veneer
                </Link>
              </li>
            </ul>
          </li>
          <li className="">
            <Link className={s.link} to="#">
              Recent Projects <FontAwesome name="angle-down" />
            </Link>
            <ul className={s.subMenu}>
              <li>
                <Link to="/projects">Recent Projects</Link>
              </li>
              <li>
                <Link to="/projects/johor-bahru">Johor Bahru</Link>
              </li>
              <li>
                <Link to="/projects/kulai">Kulai</Link>
              </li>
              <li>
                <Link to="/projects/tebrau">Tebrau</Link>
              </li>
              <li>
                <Link to="/projects/plentong">Plentong</Link>
              </li>
            </ul>
          </li>
          <li className="">
            <Link className={s.link} to="/contact-us">
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js